import React from "react";

export default function Select({ className = "", ...props }) {
  return <select className={`form-control app-select ${className}`} {...props} />;
}
